/**
 * Catálogo de permisos (§12 del encargo).
 *
 * Fuente única: el backend siembra la base de datos desde aquí y el frontend
 * comprueba contra los mismos literales. Un permiso mal escrito en el frontend
 * ROMPE LA COMPILACIÓN en lugar de fallar en silencio en tiempo de ejecución.
 */
export const PERMISSIONS = {
    DASHBOARD_VIEW: 'dashboard.view',
    DASHBOARD_EXECUTIVE_VIEW: 'dashboard.executive.view',
    HEADCOUNT_VIEW: 'headcount.view',
    TURNOVER_VIEW: 'turnover.view',
    ATTENDANCE_VIEW: 'attendance.view',
    ABSENCE_VIEW: 'absence.view',
    LATENESS_VIEW: 'lateness.view',
    OVERTIME_VIEW: 'overtime.view',
    VACATION_VIEW: 'vacation.view',
    DOCUMENTS_VIEW: 'documents.view',
    LABOR_RELATIONS_VIEW: 'labor_relations.view',
    LABOR_RELATIONS_MANAGE: 'labor_relations.manage',
    INSPECTIONS_VIEW: 'inspections.view',
    INSPECTIONS_MANAGE: 'inspections.manage',
    FINDINGS_VIEW: 'findings.view',
    FINDINGS_MANAGE: 'findings.manage',
    SYNC_VIEW: 'sync.view',
    SYNC_EXECUTE: 'sync.execute',
    USERS_VIEW: 'users.view',
    USERS_MANAGE: 'users.manage',
    ROLES_VIEW: 'roles.view',
    ROLES_MANAGE: 'roles.manage',
    SETTINGS_VIEW: 'settings.view',
    SETTINGS_MANAGE: 'settings.manage',
    INTEGRATIONS_VIEW: 'integrations.view',
    INTEGRATIONS_MANAGE: 'integrations.manage',
    AUDIT_VIEW: 'audit.view',
    EXPORTS_EXECUTE: 'exports.execute',
    /**
     * Acceso a la ficha individual de un colaborador.
     *
     * Permiso PROPIO y separado (§30): los dashboards ejecutivos son agregados y
     * no requieren ver datos de personas identificadas. Que alguien pueda ver la
     * dotación no implica que pueda ver quién la compone.
     */
    EMPLOYEE_DETAIL_VIEW: 'employee.detail.view',
};
export const ALL_PERMISSIONS = Object.values(PERMISSIONS);
/** Agrupación por módulo, para la pantalla de administración de roles. */
export const PERMISSION_MODULES = {
    dashboard: [PERMISSIONS.DASHBOARD_VIEW, PERMISSIONS.DASHBOARD_EXECUTIVE_VIEW],
    indicadores: [
        PERMISSIONS.HEADCOUNT_VIEW,
        PERMISSIONS.TURNOVER_VIEW,
        PERMISSIONS.ATTENDANCE_VIEW,
        PERMISSIONS.ABSENCE_VIEW,
        PERMISSIONS.LATENESS_VIEW,
        PERMISSIONS.OVERTIME_VIEW,
        PERMISSIONS.VACATION_VIEW,
        PERMISSIONS.DOCUMENTS_VIEW,
    ],
    gestion: [
        PERMISSIONS.LABOR_RELATIONS_VIEW,
        PERMISSIONS.LABOR_RELATIONS_MANAGE,
        PERMISSIONS.INSPECTIONS_VIEW,
        PERMISSIONS.INSPECTIONS_MANAGE,
        PERMISSIONS.FINDINGS_VIEW,
        PERMISSIONS.FINDINGS_MANAGE,
    ],
    personas: [PERMISSIONS.EMPLOYEE_DETAIL_VIEW],
    sincronizacion: [PERMISSIONS.SYNC_VIEW, PERMISSIONS.SYNC_EXECUTE],
    administracion: [
        PERMISSIONS.USERS_VIEW,
        PERMISSIONS.USERS_MANAGE,
        PERMISSIONS.ROLES_VIEW,
        PERMISSIONS.ROLES_MANAGE,
        PERMISSIONS.SETTINGS_VIEW,
        PERMISSIONS.SETTINGS_MANAGE,
        PERMISSIONS.INTEGRATIONS_VIEW,
        PERMISSIONS.INTEGRATIONS_MANAGE,
    ],
    auditoria: [PERMISSIONS.AUDIT_VIEW, PERMISSIONS.EXPORTS_EXECUTE],
};
export const ROLES = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    HR_ADMIN: 'HR_ADMIN',
    HR_ANALYST: 'HR_ANALYST',
    EXECUTIVE_VIEWER: 'EXECUTIVE_VIEWER',
};
/**
 * Nivel jerárquico. Menor número = más privilegio.
 *
 * Un usuario NO puede asignar un rol de nivel igual o superior al propio (§11):
 * impide que un HR_ADMIN se promueva a SUPER_ADMIN o cree un par que lo haga.
 */
export const ROLE_HIERARCHY = {
    SUPER_ADMIN: 0,
    HR_ADMIN: 10,
    HR_ANALYST: 20,
    EXECUTIVE_VIEWER: 30,
};
const P = PERMISSIONS;
/**
 * Permisos por rol (§11).
 *
 * HR_ADMIN NO recibe: integrations.manage, settings.manage, roles.manage ni
 * users.manage sobre SUPER_ADMIN. Es una restricción explícita del encargo:
 * «no puede modificar integraciones técnicas ni secretos, ni eliminar
 * SUPER_ADMIN, ni asignar permisos superiores a los propios».
 */
export const ROLE_PERMISSIONS = {
    SUPER_ADMIN: ALL_PERMISSIONS,
    HR_ADMIN: [
        P.DASHBOARD_VIEW,
        P.DASHBOARD_EXECUTIVE_VIEW,
        P.HEADCOUNT_VIEW,
        P.TURNOVER_VIEW,
        P.ATTENDANCE_VIEW,
        P.ABSENCE_VIEW,
        P.LATENESS_VIEW,
        P.OVERTIME_VIEW,
        P.VACATION_VIEW,
        P.DOCUMENTS_VIEW,
        P.LABOR_RELATIONS_VIEW,
        P.LABOR_RELATIONS_MANAGE,
        P.INSPECTIONS_VIEW,
        P.INSPECTIONS_MANAGE,
        P.FINDINGS_VIEW,
        P.FINDINGS_MANAGE,
        P.EMPLOYEE_DETAIL_VIEW,
        P.SYNC_VIEW,
        P.SYNC_EXECUTE,
        P.USERS_VIEW,
        P.USERS_MANAGE,
        P.ROLES_VIEW,
        P.SETTINGS_VIEW,
        P.INTEGRATIONS_VIEW,
        P.AUDIT_VIEW,
        P.EXPORTS_EXECUTE,
    ],
    HR_ANALYST: [
        P.DASHBOARD_VIEW,
        P.HEADCOUNT_VIEW,
        P.TURNOVER_VIEW,
        P.ATTENDANCE_VIEW,
        P.ABSENCE_VIEW,
        P.LATENESS_VIEW,
        P.OVERTIME_VIEW,
        P.VACATION_VIEW,
        P.DOCUMENTS_VIEW,
        P.LABOR_RELATIONS_VIEW,
        P.INSPECTIONS_VIEW,
        P.FINDINGS_VIEW,
        P.SYNC_VIEW,
        P.EXPORTS_EXECUTE,
    ],
    /** Solo información agregada. Sin ficha individual, por diseño. */
    EXECUTIVE_VIEWER: [P.DASHBOARD_VIEW, P.DASHBOARD_EXECUTIVE_VIEW],
};
//# sourceMappingURL=permissions.js.map